<template>
  <div class="city-detail-page" v-if="cityData">
    <router-link to="/cities" class="back-link">← 返回全球城市</router-link>

    <!-- 主时钟 -->
    <div class="cd-hero">
      <h1 class="cd-name">
        <span class="cd-flag">{{ cityData.flag }}</span>
        {{ cityData.label }}
      </h1>
      <div class="cd-time">{{ cityData.time }}</div>
      <div class="cd-date">{{ cityData.fullDate }}</div>
      <div class="cd-offset">{{ cityData.offset }}</div>
    </div>

    <!-- 时区信息 -->
    <div class="cd-info-grid">
      <div class="cd-info-card">
        <span class="cd-info-label">时区</span>
        <span class="cd-info-value">{{ cityData.tz }}</span>
      </div>
      <div class="cd-info-card">
        <span class="cd-info-label">UTC偏移</span>
        <span class="cd-info-value">{{ cityData.offset }}</span>
      </div>
      <div class="cd-info-card">
        <span class="cd-info-label">星期</span>
        <span class="cd-info-value">{{ cityData.weekday }}</span>
      </div>
      <div class="cd-info-card">
        <span class="cd-info-label">第几周</span>
        <span class="cd-info-value">第 {{ cityData.weekNumber }} 周</span>
      </div>
      <div class="cd-info-card">
        <span class="cd-info-label">时区缩写</span>
        <span class="cd-info-value">{{ cityData.tzAbbr }}</span>
      </div>
      <div class="cd-info-card">
        <span class="cd-info-label">夏令时</span>
        <span class="cd-info-value">{{ cityData.isDST ? '是' : '否' }}</span>
      </div>
    </div>

    <!-- 与其他城市对比 -->
    <section class="cd-compare">
      <h3>与其他城市时间对比</h3>
      <div class="compare-grid">
        <div v-for="c in compareCities" :key="c.id" class="compare-card">
          <div class="cm-name">{{ c.flag }} {{ c.label }}</div>
          <div class="cm-time">{{ c.time }}</div>
          <div class="cm-offset">{{ c.offset }}</div>
        </div>
      </div>
    </section>

    <!-- 12小时趋势 -->
    <section class="cd-timeline">
      <h3>今日时间线（每小时）</h3>
      <div class="timeline-scroll">
        <div v-for="h in 24" :key="h" class="timeline-slot" :class="{ current: h === currentHourLocal }">
          <div class="ts-hour">{{ String(h).padStart(2, '0') }}:00</div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
const COMPARE_IDS = ['Tokyo', 'Beijing', 'Singapore', 'Dubai', 'Moscow', 'London', 'Paris', 'New_York', 'Los_Angeles', 'Sydney', 'Hong_Kong', 'Seoul']
const CITIES_MAP = {
  'Tokyo': { label: '东京', flag: '🇯🇵', tz: 'Asia/Tokyo' },
  'Beijing': { label: '北京', flag: '🇨🇳', tz: 'Asia/Shanghai' },
  'Shanghai': { label: '上海', flag: '🇨🇳', tz: 'Asia/Shanghai' },
  'Hong_Kong': { label: '香港', flag: '🇭🇰', tz: 'Asia/Hong_Kong' },
  'Seoul': { label: '首尔', flag: '🇰🇷', tz: 'Asia/Seoul' },
  'Singapore': { label: '新加坡', flag: '🇸🇬', tz: 'Asia/Singapore' },
  'Bangkok': { label: '曼谷', flag: '🇹🇭', tz: 'Asia/Bangkok' },
  'Jakarta': { label: '雅加达', flag: '🇮🇩', tz: 'Asia/Jakarta' },
  'Manila': { label: '马尼拉', flag: '🇵🇭', tz: 'Asia/Manila' },
  'Kuala_Lumpur': { label: '吉隆坡', flag: '🇲🇾', tz: 'Asia/Kuala_Lumpur' },
  'Taipei': { label: '台北', flag: '🇨🇳', tz: 'Asia/Taipei' },
  'Hanoi': { label: '河内', flag: '🇻🇳', tz: 'Asia/Ho_Chi_Minh' },
  'Mumbai': { label: '孟买', flag: '🇮🇳', tz: 'Asia/Kolkata' },
  'New_Delhi': { label: '新德里', flag: '🇮🇳', tz: 'Asia/Kolkata' },
  'Bangalore': { label: '班加罗尔', flag: '🇮🇳', tz: 'Asia/Kolkata' },
  'Dubai': { label: '迪拜', flag: '🇦🇪', tz: 'Asia/Dubai' },
  'Abu_Dhabi': { label: '阿布扎比', flag: '🇦🇪', tz: 'Asia/Dubai' },
  'Riyadh': { label: '利雅得', flag: '🇸🇦', tz: 'Asia/Riyadh' },
  'Doha': { label: '多哈', flag: '🇶🇦', tz: 'Asia/Qatar' },
  'Karachi': { label: '卡拉奇', flag: '🇵🇰', tz: 'Asia/Karachi' },
  'Kathmandu': { label: '加德满都', flag: '🇳🇵', tz: 'Asia/Kathmandu' },
  'Colombo': { label: '科伦坡', flag: '🇱🇰', tz: 'Asia/Colombo' },
  'Yangon': { label: '仰光', flag: '🇲🇲', tz: 'Asia/Yangon' },
  'Dhaka': { label: '达卡', flag: '🇧🇩', tz: 'Asia/Dhaka' },
  'Tehran': { label: '德黑兰', flag: '🇮🇷', tz: 'Asia/Tehran' },
  'Baghdad': { label: '巴格达', flag: '🇮🇶', tz: 'Asia/Baghdad' },
  'Jerusalem': { label: '耶路撒冷', flag: '🇮🇱', tz: 'Asia/Jerusalem' },
  'Almaty': { label: '阿拉木图', flag: '🇰🇿', tz: 'Asia/Almaty' },
  'Tashkent': { label: '塔什干', flag: '🇺🇿', tz: 'Asia/Tashkent' },
  'Ulaanbaatar': { label: '乌兰巴托', flag: '🇲🇳', tz: 'Asia/Ulaanbaatar' },
  'Phnom_Penh': { label: '金边', flag: '🇰🇭', tz: 'Asia/Phnom_Penh' },
  'Vientiane': { label: '万象', flag: '🇱🇦', tz: 'Asia/Vientiane' },
  'Macau': { label: '澳门', flag: '🇲🇴', tz: 'Asia/Macau' },
  'Baku': { label: '巴库', flag: '🇦🇿', tz: 'Asia/Baku' },
  'Tbilisi': { label: '第比利斯', flag: '🇬🇪', tz: 'Asia/Tbilisi' },
  'Yerevan': { label: '埃里温', flag: '🇦🇲', tz: 'Asia/Yerevan' },
  'Kuwait_City': { label: '科威特城', flag: '🇰🇼', tz: 'Asia/Kuwait' },
  'Muscat': { label: '马斯喀特', flag: '🇴🇲', tz: 'Asia/Muscat' },
  'Manama': { label: '麦纳麦', flag: '🇧🇭', tz: 'Asia/Bahrain' },
  'Amman': { label: '安曼', flag: '🇯🇴', tz: 'Asia/Amman' },
  'Beirut': { label: '贝鲁特', flag: '🇱🇧', tz: 'Asia/Beirut' },
  'Damascus': { label: '大马士革', flag: '🇸🇾', tz: 'Asia/Damascus' },
  'Pyongyang': { label: '平壤', flag: '🇰🇵', tz: 'Asia/Pyongyang' },
  'London': { label: '伦敦', flag: '🇬🇧', tz: 'Europe/London' },
  'Paris': { label: '巴黎', flag: '🇫🇷', tz: 'Europe/Paris' },
  'Berlin': { label: '柏林', flag: '🇩🇪', tz: 'Europe/Berlin' },
  'Moscow': { label: '莫斯科', flag: '🇷🇺', tz: 'Europe/Moscow' },
  'Rome': { label: '罗马', flag: '🇮🇹', tz: 'Europe/Rome' },
  'Madrid': { label: '马德里', flag: '🇪🇸', tz: 'Europe/Madrid' },
  'Amsterdam': { label: '阿姆斯特丹', flag: '🇳🇱', tz: 'Europe/Amsterdam' },
  'Brussels': { label: '布鲁塞尔', flag: '🇧🇪', tz: 'Europe/Brussels' },
  'Vienna': { label: '维也纳', flag: '🇦🇹', tz: 'Europe/Vienna' },
  'Zurich': { label: '苏黎世', flag: '🇨🇭', tz: 'Europe/Zurich' },
  'Stockholm': { label: '斯德哥尔摩', flag: '🇸🇪', tz: 'Europe/Stockholm' },
  'Oslo': { label: '奥斯陆', flag: '🇳🇴', tz: 'Europe/Oslo' },
  'Copenhagen': { label: '哥本哈根', flag: '🇩🇰', tz: 'Europe/Copenhagen' },
  'Helsinki': { label: '赫尔辛基', flag: '🇫🇮', tz: 'Europe/Helsinki' },
  'Warsaw': { label: '华沙', flag: '🇵🇱', tz: 'Europe/Warsaw' },
  'Prague': { label: '布拉格', flag: '🇨🇿', tz: 'Europe/Prague' },
  'Budapest': { label: '布达佩斯', flag: '🇭🇺', tz: 'Europe/Budapest' },
  'Lisbon': { label: '里斯本', flag: '🇵🇹', tz: 'Europe/Lisbon' },
  'Athens': { label: '雅典', flag: '🇬🇷', tz: 'Europe/Athens' },
  'Dublin': { label: '都柏林', flag: '🇮🇪', tz: 'Europe/Dublin' },
  'Istanbul': { label: '伊斯坦布尔', flag: '🇹🇷', tz: 'Europe/Istanbul' },
  'Kiev': { label: '基辅', flag: '🇺🇦', tz: 'Europe/Kiev' },
  'Bucharest': { label: '布加勒斯特', flag: '🇷🇴', tz: 'Europe/Bucharest' },
  'Belgrade': { label: '贝尔格莱德', flag: '🇷🇸', tz: 'Europe/Belgrade' },
  'Sofia': { label: '索非亚', flag: '🇧🇬', tz: 'Europe/Sofia' },
  'Reykjavik': { label: '雷克雅未克', flag: '🇮🇸', tz: 'Atlantic/Reykjavik' },
  'Luxembourg': { label: '卢森堡市', flag: '🇱🇺', tz: 'Europe/Luxembourg' },
  'Bratislava': { label: '布拉迪斯拉发', flag: '🇸🇰', tz: 'Europe/Bratislava' },
  'Vilnius': { label: '维尔纽斯', flag: '🇱🇹', tz: 'Europe/Vilnius' },
  'Riga': { label: '里加', flag: '🇱🇻', tz: 'Europe/Riga' },
  'Tallinn': { label: '塔林', flag: '🇪🇪', tz: 'Europe/Tallinn' },
  'Minsk': { label: '明斯克', flag: '🇧🇾', tz: 'Europe/Minsk' },
  'Chisinau': { label: '基希讷乌', flag: '🇲🇩', tz: 'Europe/Chisinau' },
  'Zagreb': { label: '萨格勒布', flag: '🇭🇷', tz: 'Europe/Zagreb' },
  'Sarajevo': { label: '萨拉热窝', flag: '🇧🇦', tz: 'Europe/Sarajevo' },
  'Ljubljana': { label: '卢布尔雅那', flag: '🇸🇮', tz: 'Europe/Ljubljana' },
  'Podgorica': { label: '波德戈里察', flag: '🇲🇪', tz: 'Europe/Podgorica' },
  'Skopje': { label: '斯科普里', flag: '🇲🇰', tz: 'Europe/Skopje' },
  'Tirana': { label: '地拉那', flag: '🇦🇱', tz: 'Europe/Tirane' },
  'Edinburgh': { label: '爱丁堡', flag: '🇬🇧', tz: 'Europe/London' },
  'Barcelona': { label: '巴塞罗那', flag: '🇪🇸', tz: 'Europe/Madrid' },
  'Munich': { label: '慕尼黑', flag: '🇩🇪', tz: 'Europe/Berlin' },
  'Milan': { label: '米兰', flag: '🇮🇹', tz: 'Europe/Rome' },
  'New_York': { label: '纽约', flag: '🇺🇸', tz: 'America/New_York' },
  'Los_Angeles': { label: '洛杉矶', flag: '🇺🇸', tz: 'America/Los_Angeles' },
  'Chicago': { label: '芝加哥', flag: '🇺🇸', tz: 'America/Chicago' },
  'Toronto': { label: '多伦多', flag: '🇨🇦', tz: 'America/Toronto' },
  'Vancouver': { label: '温哥华', flag: '🇨🇦', tz: 'America/Vancouver' },
  'San_Francisco': { label: '旧金山', flag: '🇺🇸', tz: 'America/Los_Angeles' },
  'Seattle': { label: '西雅图', flag: '🇺🇸', tz: 'America/Los_Angeles' },
  'Boston': { label: '波士顿', flag: '🇺🇸', tz: 'America/New_York' },
  'Washington_DC': { label: '华盛顿', flag: '🇺🇸', tz: 'America/New_York' },
  'Miami': { label: '迈阿密', flag: '🇺🇸', tz: 'America/New_York' },
  'Dallas': { label: '达拉斯', flag: '🇺🇸', tz: 'America/Chicago' },
  'Houston': { label: '休斯顿', flag: '🇺🇸', tz: 'America/Chicago' },
  'Atlanta': { label: '亚特兰大', flag: '🇺🇸', tz: 'America/New_York' },
  'Denver': { label: '丹佛', flag: '🇺🇸', tz: 'America/Denver' },
  'Phoenix': { label: '凤凰城', flag: '🇺🇸', tz: 'America/Phoenix' },
  'Las_Vegas': { label: '拉斯维加斯', flag: '🇺🇸', tz: 'America/Los_Angeles' },
  'Montreal': { label: '蒙特利尔', flag: '🇨🇦', tz: 'America/Toronto' },
  'Calgary': { label: '卡尔加里', flag: '🇨🇦', tz: 'America/Edmonton' },
  'Ottawa': { label: '渥太华', flag: '🇨🇦', tz: 'America/Toronto' },
  'Mexico_City': { label: '墨西哥城', flag: '🇲🇽', tz: 'America/Mexico_City' },
  'Havana': { label: '哈瓦那', flag: '🇨🇺', tz: 'America/Havana' },
  'Panama_City': { label: '巴拿马城', flag: '🇵🇦', tz: 'America/Panama' },
  'San_Jose_CR': { label: '圣何塞', flag: '🇨🇷', tz: 'America/Costa_Rica' },
  'Guatemala_City': { label: '危地马拉城', flag: '🇬🇹', tz: 'America/Guatemala' },
  'Sao_Paulo': { label: '圣保罗', flag: '🇧🇷', tz: 'America/Sao_Paulo' },
  'Rio_de_Janeiro': { label: '里约热内卢', flag: '🇧🇷', tz: 'America/Sao_Paulo' },
  'Brasilia': { label: '巴西利亚', flag: '🇧🇷', tz: 'America/Sao_Paulo' },
  'Buenos_Aires': { label: '布宜诺斯艾利斯', flag: '🇦🇷', tz: 'America/Argentina/Buenos_Aires' },
  'Santiago': { label: '圣地亚哥', flag: '🇨🇱', tz: 'America/Santiago' },
  'Lima': { label: '利马', flag: '🇵🇪', tz: 'America/Lima' },
  'Bogota': { label: '波哥大', flag: '🇨🇴', tz: 'America/Bogota' },
  'Caracas': { label: '加拉加斯', flag: '🇻🇪', tz: 'America/Caracas' },
  'Quito': { label: '基多', flag: '🇪🇨', tz: 'America/Guayaquil' },
  'La_Paz': { label: '拉巴斯', flag: '🇧🇴', tz: 'America/La_Paz' },
  'Montevideo': { label: '蒙得维的亚', flag: '🇺🇾', tz: 'America/Montevideo' },
  'Asuncion': { label: '亚松森', flag: '🇵🇾', tz: 'America/Asuncion' },
  'Paramaribo': { label: '帕拉马里博', flag: '🇸🇷', tz: 'America/Paramaribo' },
  'Georgetown': { label: '乔治敦', flag: '🇬🇾', tz: 'America/Guyana' },
  'Sydney': { label: '悉尼', flag: '🇦🇺', tz: 'Australia/Sydney' },
  'Melbourne': { label: '墨尔本', flag: '🇦🇺', tz: 'Australia/Melbourne' },
  'Brisbane': { label: '布里斯班', flag: '🇦🇺', tz: 'Australia/Brisbane' },
  'Perth': { label: '珀斯', flag: '🇦🇺', tz: 'Australia/Perth' },
  'Adelaide': { label: '阿德莱德', flag: '🇦🇺', tz: 'Australia/Adelaide' },
  'Auckland': { label: '奥克兰', flag: '🇳🇿', tz: 'Pacific/Auckland' },
  'Wellington': { label: '惠灵顿', flag: '🇳🇿', tz: 'Pacific/Auckland' },
  'Suva': { label: '苏瓦', flag: '🇫🇯', tz: 'Pacific/Fiji' },
  'Port_Moresby': { label: '莫尔兹比港', flag: '🇵🇬', tz: 'Pacific/Port_Moresby' },
  'Noumea': { label: '努美阿', flag: '🇳🇨', tz: 'Pacific/Noumea' },
  'Apia': { label: '阿皮亚', flag: '🇼🇸', tz: 'Pacific/Apia' },
  'Nukualofa': { label: '努库阿洛法', flag: '🇹🇴', tz: 'Pacific/Tongatapu' },
  'Cairo': { label: '开罗', flag: '🇪🇬', tz: 'Africa/Cairo' },
  'Lagos': { label: '拉各斯', flag: '🇳🇬', tz: 'Africa/Lagos' },
  'Johannesburg': { label: '约翰内斯堡', flag: '🇿🇦', tz: 'Africa/Johannesburg' },
  'Cape_Town': { label: '开普敦', flag: '🇿🇦', tz: 'Africa/Johannesburg' },
  'Nairobi': { label: '内罗毕', flag: '🇰🇪', tz: 'Africa/Nairobi' },
  'Addis_Ababa': { label: '亚的斯亚贝巴', flag: '🇪🇹', tz: 'Africa/Addis_Ababa' },
  'Khartoum': { label: '喀土穆', flag: '🇸🇩', tz: 'Africa/Khartoum' },
  'Casablanca': { label: '卡萨布兰卡', flag: '🇲🇦', tz: 'Africa/Casablanca' },
  'Algiers': { label: '阿尔及尔', flag: '🇩🇿', tz: 'Africa/Algiers' },
  'Tunis': { label: '突尼斯市', flag: '🇹🇳', tz: 'Africa/Tunis' },
  'Accra': { label: '阿克拉', flag: '🇬🇭', tz: 'Africa/Accra' },
  'Dakar': { label: '达喀尔', flag: '🇸🇳', tz: 'Africa/Dakar' },
  'Abidjan': { label: '阿比让', flag: '🇨🇮', tz: 'Africa/Abidjan' },
  'Luanda': { label: '罗安达', flag: '🇦🇴', tz: 'Africa/Luanda' },
  'Tripoli': { label: '的黎波里', flag: '🇱🇾', tz: 'Africa/Tripoli' },
  'Dar_es_Salaam': { label: '达累斯萨拉姆', flag: '🇹🇿', tz: 'Africa/Dar_es_Salaam' },
  'Maputo': { label: '马普托', flag: '🇲🇿', tz: 'Africa/Maputo' },
  'Kampala': { label: '坎帕拉', flag: '🇺🇬', tz: 'Africa/Kampala' },
  'Rabat': { label: '拉巴特', flag: '🇲🇦', tz: 'Africa/Casablanca' },
  'Harare': { label: '哈拉雷', flag: '🇿🇼', tz: 'Africa/Harare' },
  'Windhoek': { label: '温得和克', flag: '🇳🇦', tz: 'Africa/Windhoek' },
  'Gaborone': { label: '哈博罗内', flag: '🇧🇼', tz: 'Africa/Gaborone' },
  'Lusaka': { label: '卢萨卡', flag: '🇿🇲', tz: 'Africa/Lusaka' },
  'Kigali': { label: '基加利', flag: '🇷🇼', tz: 'Africa/Kigali' },
  'Bamako': { label: '巴马科', flag: '🇲🇱', tz: 'Africa/Bamako' },
  'Ouagadougou': { label: '瓦加杜古', flag: '🇧🇫', tz: 'Africa/Ouagadougou' },
  'Yaounde': { label: '雅温得', flag: '🇨🇲', tz: 'Africa/Douala' },
  'Antananarivo': { label: '塔那那利佛', flag: '🇲🇬', tz: 'Indian/Antananarivo' },
  'Mogadishu': { label: '摩加迪沙', flag: '🇸🇴', tz: 'Africa/Mogadishu' }
}

export default {
  name: 'CityDetailPage',
  props: { name: { type: String, required: true } },
  data() {
    return {
      cityData: null,
      compareCities: [],
      currentHourLocal: new Date().getHours(),
      timer: null
    }
  },
  mounted() {
    this.updateAll()
    this.timer = setInterval(this.updateAll, 1000)
  },
  beforeUnmount() {
    if (this.timer) clearInterval(this.timer)
  },
  methods: {
    updateAll() {
      const now = new Date()
      const meta = CITIES_MAP[this.name]
      if (!meta) { this.cityData = null; return }

      // Main city
      try {
        const time = now.toLocaleTimeString('zh-CN', { timeZone: meta.tz, hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false })
        const fullDate = now.toLocaleDateString('zh-CN', { timeZone: meta.tz, year: 'numeric', month: 'long', day: 'numeric' })
        const weekday = now.toLocaleDateString('zh-CN', { timeZone: meta.tz, weekday: 'long' })
        let offset = '', tzAbbr = '', isDST = false
        try {
          const partsShort = new Intl.DateTimeFormat('en-US', { timeZone: meta.tz, timeZoneName: 'short' }).formatToParts(now)
          const partsOffset = new Intl.DateTimeFormat('en-US', { timeZone: meta.tz, timeZoneName: 'shortOffset' }).formatToParts(now)
          const o = partsOffset.find(p => p.type === 'timeZoneName')
          const a = partsShort.find(p => p.type === 'timeZoneName')
          if (o) offset = o.value
          if (a) tzAbbr = a.value
          isDST = tzAbbr && (tzAbbr.includes('DT') || tzAbbr.includes('ST') && !tzAbbr.includes('T'))
        } catch (e) { /* ignore */ }

        // Week number
        const d = new Date(now.toLocaleString('en-US', { timeZone: meta.tz }))
        const jan1 = new Date(d.getFullYear(), 0, 1)
        const weekNumber = Math.ceil(((d - jan1) / 86400000 + jan1.getDay() + 1) / 7)

        this.cityData = {
          ...meta,
          time, fullDate, weekday, offset, tzAbbr, isDST, weekNumber,
          tz: meta.tz
        }

        // Compare cities
        this.compareCities = COMPARE_IDS
          .filter(id => id !== this.name)
          .map(id => {
            const cm = CITIES_MAP[id]
            if (!cm) return null
            try {
              const t = now.toLocaleTimeString('zh-CN', { timeZone: cm.tz, hour: '2-digit', minute: '2-digit', hour12: false })
              let o = ''
              try {
                const p = new Intl.DateTimeFormat('en-US', { timeZone: cm.tz, timeZoneName: 'shortOffset' }).formatToParts(now)
                const f = p.find(pp => pp.type === 'timeZoneName')
                if (f) o = f.value
              } catch (e) { /* ignore */ }
              return { id, ...cm, time: t, offset: o }
            } catch (e) { return null }
          })
          .filter(Boolean)
      } catch (e) {
        this.cityData = null
      }
    }
  }
}
</script>

<style scoped>
.city-detail-page {
  max-width: 900px;
  margin: 0 auto;
  padding: 0 16px 40px;
}

.back-link {
  display: inline-block;
  margin-top: 16px;
  font-size: 13px;
  color: #1677ff;
  text-decoration: none;
}
.back-link:hover { text-decoration: underline; }

.cd-hero {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  border-radius: 16px;
  padding: 40px 24px;
  text-align: center;
  color: #fff;
  margin-top: 20px;
}
.cd-name { font-size: 26px; font-weight: 700; margin-bottom: 16px; }
.cd-flag { font-size: 36px; margin-right: 8px; vertical-align: middle; }
.cd-time {
  font-size: 56px;
  font-weight: 200;
  font-family: 'SF Mono', 'Consolas', 'Menlo', monospace;
  letter-spacing: 4px;
  margin-bottom: 8px;
}
.cd-date { font-size: 16px; color: #a0b4d0; margin-bottom: 4px; }
.cd-offset { font-size: 14px; color: #5b8def; font-weight: 600; }

.cd-info-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-top: 20px;
}
.cd-info-card {
  background: #fff;
  border-radius: 10px;
  padding: 18px 14px;
  text-align: center;
  box-shadow: 0 1px 6px rgba(0,0,0,0.04);
}
.cd-info-label { display: block; font-size: 12px; color: #999; margin-bottom: 4px; }
.cd-info-value { display: block; font-size: 16px; font-weight: 600; color: #1a1a2e; }

.cd-compare { margin-top: 28px; }
.cd-compare h3, .cd-timeline h3 { font-size: 16px; color: #333; margin-bottom: 12px; }

.compare-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}
.compare-card {
  background: #fff;
  border-radius: 10px;
  padding: 14px 10px;
  text-align: center;
  box-shadow: 0 1px 6px rgba(0,0,0,0.04);
}
.cm-name { font-size: 13px; font-weight: 600; margin-bottom: 4px; color: #333; }
.cm-time {
  font-size: 20px;
  font-weight: 300;
  font-family: 'SF Mono', 'Consolas', 'Menlo', monospace;
  color: #1a1a2e;
}
.cm-offset { font-size: 11px; color: #1677ff; margin-top: 2px; font-weight: 600; }

.cd-timeline { margin-top: 28px; }
.timeline-scroll {
  display: flex;
  gap: 6px;
  overflow-x: auto;
  padding: 10px 0;
}
.timeline-slot {
  min-width: 52px;
  padding: 8px 6px;
  background: #fff;
  border-radius: 8px;
  text-align: center;
  font-size: 11px;
  color: #888;
  flex-shrink: 0;
}
.timeline-slot.current {
  background: #1677ff;
  color: #fff;
  font-weight: 600;
}

@media (max-width: 768px) {
  .cd-info-grid { grid-template-columns: repeat(2, 1fr); }
  .compare-grid { grid-template-columns: repeat(3, 1fr); }
  .cd-time { font-size: 40px; }
}
@media (max-width: 480px) {
  .compare-grid { grid-template-columns: repeat(2, 1fr); }
  .cd-time { font-size: 32px; }
}
</style>
